/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Caption_Previous_OrderInputs */

const vi_carrier_legacy_caption_previous_order = /** @type {(inputs: Carrier_Legacy_Caption_Previous_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giống đơn trước của khách`)
};

/**

* @param {Carrier_Legacy_Caption_Previous_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_caption_previous_order = /** @type {((inputs?: Carrier_Legacy_Caption_Previous_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Caption_Previous_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_caption_previous_order(inputs)
});